import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../../lib/api";
import { Printer, Copy, RefreshCw } from "lucide-react";

export function PlannersAdmin({ hdr }) {
  const [items, setItems] = useState([]);
  const load = useCallback(() => axios.get(`${API}/admin/planners`, hdr()).then(({ data }) => setItems(data)).catch(() => {}), [hdr]);
  useEffect(() => { load(); }, [load]);
  const origin = window.location.origin;
  const copy = (txt) => { navigator.clipboard.writeText(txt); toast.success("Copied"); };

  return (
    <div data-testid="admin-planners" className="space-y-6">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h3 className="font-serif text-2xl font-light">Referral partners</h3>
          <p className="text-neutral-500 text-sm mt-1">Planners and venues who signed up at {origin}/planners. Each has a personal link; Incognito requests from it are counted here.</p>
        </div>
        <div className="flex gap-3 items-center">
          <a href="/card" target="_blank" rel="noreferrer" data-testid="admin-print-general-cards" className="btn-amber rounded-full px-4 py-2 text-xs flex items-center gap-1.5"><Printer size={12} /> Print my own QR cards</a>
          <button onClick={load} className="text-sm text-neutral-400 flex items-center gap-1 hover:text-white"><RefreshCw size={13} /> Refresh</button>
        </div>
      </div>
      {items.length === 0 && <div className="text-neutral-500 py-10">No partners yet. Share {origin}/planners with planners and venues.</div>}
      {items.map((p) => {
        const link = `${origin}/incognito?ref=${p.code}`;
        return (
          <div key={p.id} data-testid={`planner-row-${p.code}`} className="border border-white/10 rounded-lg p-4 bg-obsidian-800 flex flex-wrap items-center gap-4">
            <div className="flex-1 min-w-[220px]">
              <div className="font-serif text-lg">{p.business} <span className="text-xs text-neutral-500 capitalize">· {p.role}</span></div>
              <div className="text-xs text-neutral-400">{p.name} · <a href={`mailto:${p.email}`} className="hover:text-amber-glow">{p.email}</a>{p.phone ? ` · ${p.phone}` : ""}{p.city ? ` · ${p.city}` : ""}</div>
              {p.notes && <div className="text-sm text-neutral-300 mt-1">{p.notes}</div>}
            </div>
            <div className="text-center">
              <div data-testid={`planner-referrals-${p.code}`} className="font-serif text-3xl text-amber-glow">{p.referrals}</div>
              <div className="overline-label">Referrals</div>
            </div>
            <button data-testid={`planner-copy-${p.code}`} onClick={() => copy(link)} className="text-xs border border-white/15 rounded-full px-3 py-1.5 flex items-center gap-1 hover:border-amber-glow"><Copy size={12} /> Link</button>
            <a href={`/card?ref=${p.code}`} target="_blank" rel="noreferrer" data-testid={`planner-cards-${p.code}`} className="text-xs border border-white/15 rounded-full px-3 py-1.5 flex items-center gap-1 hover:border-amber-glow"><Printer size={12} /> QR cards</a>
          </div>
        );
      })}
    </div>
  );
}
